import { Button, Flex, Image, Text } from '@chakra-ui/react';
import { FormattedNumber } from 'react-intl';
import StreamGoldIcon from '../../assets/store/StreamGold.svg';
import { AuthenticatedComponent } from '../../auth/keycloak';
import { ProductDef } from '../../service/inventory';

interface CurrencyListItemProps {
    virtualPackage: ProductDef;
    onClick(product: ProductDef): void;
}

export const CurrencyListItem: AuthenticatedComponent<CurrencyListItemProps> = ({
    keycloak,
    virtualPackage,
    onClick,
}) => {
    return (
        <Flex className={'currency-container'}>
            <Image src={StreamGoldIcon} />
            <Text>{virtualPackage.product_name}</Text>
            <Button
                className="currency-button"
                isDisabled={keycloak.hasResourceRole('disable_purchase', 'realm')}
                onClick={() => {
                    onClick(virtualPackage);
                }}
            >
                <FormattedNumber
                    value={virtualPackage.cost[0].quantity}
                    style={'currency'}
                    currency={virtualPackage.cost[0].currency}
                />
            </Button>
        </Flex>
    );
};
